import Vue from 'vue';
import VueRouter from 'vue-router';
import LayoutOne from '../views/LayoutOne.vue';
import Result from '../views/Result.vue';
import loginService from '../services/login.service';
import ApiService from '../services/api.service';
import TokenService from '../services/storage.service';

Vue.use(VueRouter);

const layoutOneRoutes = [
  {
    path: '/',
    name: 'LayoutOne',
    component: LayoutOne,
  },
  {
    path: '/danke',
    name: 'Result',
    component: Result,
  },
];

// eslint-disable-next-line import/prefer-default-export
export const layoutOneRouter = new VueRouter({
  routes: layoutOneRoutes,
});

layoutOneRouter.beforeEach((to, from, next) => {
  const loggedIn = !!TokenService.getToken();
  if (!loggedIn) {
    loginService.login().then(() => {
      ApiService.setHeader().finally(() => {
        next();
      });
    });
  } else {
    ApiService.setHeader();
    next();
  }
});
